export default __webpack_public_path__ + "static/media/kitchen3-before2-1024w.2e431260.png";